// One id per page load, used with requestSequence to group requests in logs.
export const pageLoadId =
  typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function'
    ? crypto.randomUUID()
    : `${Date.now()}-${Math.random()}`;

export const requestSequence = { value: 0 };
